import {useQuery} from "react-query";
import {useSelector} from "react-redux";
import * as CustomerService from ".././services/customer-service";

export default function useStatuses() {
  const authState = useSelector((state) => state.auth);
  return useQuery("statuses", () => CustomerService.fetchStatuses(authState.roles), {
    initialData: [],
    initialStale: true,
    keepPreviousData: true,
    refetchOnWindowFocus: false,
  });
}
